import { defineStore } from "pinia";
import api from "~/config/extensionsApi";
import { postApiAxios } from "~/helpers";

export const useOderStore = defineStore("oder", {
  state: () => ({
    paymentUrl: null,
    redirectUrl: null,
    orderInfo: null,
    productsParent: [],
    loading: false,
    error: null,
  }),

  getters: {
    getItemsOrder: (state) => {
      if (!state.orderInfo?.[0]?.items) {
        return [];
      }

      const items = state.orderInfo[0].items;
      return items.map((item) => {
        const parentSku = item.sku.split("-")[0];
        const parentProduct = state.productsParent.find((product) => product.sku === parentSku);
        return {
          ...item,
          productParent: parentProduct || null,
        };
      });
    },
  },

  actions: {
    async createPaymentUrlVnpay(body) {
      this.loading = true;
      this.error = null;

      try {
        const config = {
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json; charset=UTF-8",
          },
        };

        const result = await postApiAxios(api.vnpay.vnpay_create_payment, body, config);
        this.paymentUrl = result;
      } catch (err) {
        this.error = err.message || "Failed to fetch order data";
        console.error("Error fetching order:", err);
      } finally {
        this.loading = false;
      }
    },

    async createPaymentUrlShopee(body) {
      this.loading = true;
      this.error = null;

      try {
        const result = await postApiAxios(api.shopeepay.shopeepay_create_payment, body);
        this.redirectUrl = result;
      } catch (err) {
        this.error = err.message || "Failed to fetch order data";
        console.error("Error fetching order:", err);
      } finally {
        this.loading = false;
      }
    },

    async changePayment(incrementId: string, paymentMethod: string) {
      this.loading = true;
      this.error = null;

      try {
        let params = {
          increment_id: incrementId,
          payment_method: paymentMethod,
        };
        const result = await postApiAxios(api.sales.change_payment, params);
        if (result?.code === 200) {
          return result.result;
        } else return null;
      } catch (err) {
        this.error = err.message || "Failed to fetch change payment method";
        console.error("Error fetching change payment method:", err);
        throw err;
      } finally {
        this.loading = false;
      }
    },

    async changeStatusShopeeOrder(orderId: string, amount: string) {
      this.loading = true;
      this.error = null;

      try {
        let params = {
          orderId: orderId,
          amount: amount,
        };
        const result = await postApiAxios(api.shopeepay.shopeepay_trans, params);
        if (result?.code === 200) {
          return result.result;
        } else return null;
      } catch (err) {
        this.error = err.message || "Failed to fetch change payment method";
        console.error("Error fetching change payment method:", err);
        throw err;
      } finally {
        this.loading = false;
      }
    },


  },
});
